import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Button } from '../Common/Button';
import { Badge } from '../Common/Badge';
import { LoadingSpinner } from '../Common/LoadingSpinner';
import { showToast } from '../../hooks/useToast';

export function ActiveUsers() {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    Promise.all([
      api.adminListUsers('user'),
      api.adminListUsers('admin'),
      api.adminListUsers('inactive'),
    ]).then(([u, a, i]) => {
      setUsers([...a.users, ...u.users, ...i.users]);
    }).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const action = async (fn: (id: string) => Promise<any>, id: string, label: string) => {
    if (!window.confirm(`${label}?`)) return;
    try { await fn(id); showToast('success', `${label} succeeded`); load(); }
    catch (err: any) { showToast('error', err.message ?? 'Failed'); }
  };

  if (loading) return <LoadingSpinner label="Loading…" />;

  return (
    <div className="space-y-2">
      {users.map(u => (
        <div key={u.id} className="bg-surface border border-border rounded-lg px-4 py-3 flex items-center justify-between">
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 mb-1">
              <div className="text-sm font-medium text-text-primary truncate">{u.displayName}</div>
              <Badge variant={u.role === 'admin' ? 'accent' : u.role === 'inactive' ? 'neutral' : 'success'}>{u.role}</Badge>
            </div>
            <div className="text-xs text-text-muted truncate">{u.email}</div>
            <div className="text-[10px] uppercase tracking-wider text-text-hint mt-1">
              {u.lastLoginAt ? `Last login: ${new Date(u.lastLoginAt).toLocaleDateString()}` : 'Never signed in'}
            </div>
          </div>
          <div className="flex items-center gap-2 ml-3">
            {u.role === 'user'     && <Button size="sm" onClick={() => action(api.adminPromote, u.id, 'Promote to admin')}>Promote</Button>}
            {u.role !== 'inactive' && <Button size="sm" variant="danger" onClick={() => action(api.adminDeactivate, u.id, 'Deactivate user')}>Deactivate</Button>}
            {u.role === 'inactive' && <Button size="sm" onClick={() => action(api.adminApprove, u.id, 'Reactivate as user')}>Reactivate</Button>}
          </div>
        </div>
      ))}
    </div>
  );
}
